export const organizationDeviceKeys = {
  all: ['organization-devices'],
} as const;
